import type { Store } from 'effector'
import type { UiCategoryWithChannels } from '~/shared/interfaces'

import { api } from '@setplex/tria-api'
import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'
import { formatCategoryWithChannelsToUi } from '~/entities/tv/channels/lib'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'

export const $infiniteChannelsFormatted: Store<UiCategoryWithChannels | null> =
  combine(
    api.tv.$infiniteChannelsCategory,
    ssePurchasesModel.$channel,
    i18n.$t,
    (data, adjust, { t }) => formatCategoryWithChannelsToUi(data, adjust, t)
  )

export const $infiniteTvTitle: Store<string> = combine(i18n.$t, ({ t }) =>
  t('all')
)
